import shoppableImage from '../helpers/ShoppableImage';

let module_name = '';
// let index = '';
const generateContentBlock = (content) => {
  const html = `
    <div class="Module-${module_name}__Block Module-${module_name}__Block--Content">
      ${content.content}
    </div>
  `;
  return html;
};

const extractColumnContent = (modules, settings) => {
  let html = '';
  modules.forEach((module) => {
    switch (module.acf_fc_layout) {
      case 'image':
        html += shoppableImage(module, settings.accent_color.accent_color);
        break;
      case 'content':
        html += generateContentBlock(module);
        break;
      default:
        break;
    }
  });
  return html;
};

// export default (settings, name, i) => {
export default (settings, name) => {
  module_name = name;
  // index = i;

  const content_html = `
  <div class="Module-${module_name}__Column Module-${module_name}__Left">
    <div class="Module-${module_name}__Column-Inner Module-${module_name}__Left-inner">
      ${extractColumnContent(settings.column_left || [], settings)}
    </div>
  </div>
  <div class="Module-${module_name}__Column Module-${module_name}__Right">
    <div class="Module-${module_name}__Column-Inner Module-${module_name}__Right-inner">
      ${extractColumnContent(settings.column_right || [], settings)}
      </div>
  </div>
  `;
  return content_html;
};
